import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { ScrollText, ShieldCheck, ShieldOff, LogIn, LogOut, Megaphone } from "lucide-react";

const ACTION_META = {
  set_role: { icon: ShieldCheck, label: "Role change", color: "text-primary" },
  impersonate: { icon: LogIn, label: "Impersonate", color: "text-cyan-300" },
  stop_impersonate: { icon: LogOut, label: "Exit impersonation", color: "text-zinc-400" },
  announcement: { icon: Megaphone, label: "Announcement", color: "text-amber-400" },
};

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit").then(({ data }) => setLogs(data)).catch(() => {}); }, []);

  const describe = (l) => {
    if (l.action === "set_role") return `Set ${l.target_email || l.detail?.target} → ${l.detail?.role}`;
    if (l.action === "impersonate") return `Started acting as ${l.target_email || l.detail?.target}`;
    if (l.action === "stop_impersonate") return `Stopped acting as ${l.target_email || l.detail?.target}`;
    if (l.action === "announcement") return `Broadcast "${l.detail?.title}" (${l.detail?.audience})`;
    return JSON.stringify(l.detail || {});
  };

  return (
    <div data-testid="admin-audit-page">
      <div className="mb-8"><h4 className="text-xs font-semibold tracking-[0.25em] uppercase text-primary mb-2">Admin</h4><h1 className="font-heading text-4xl font-black tracking-tighter uppercase">Audit Log</h1></div>

      <div className="bg-card border border-border rounded-lg overflow-hidden">
        {logs.length === 0 ? <div className="text-center py-16"><ScrollText className="h-10 w-10 text-zinc-700 mx-auto mb-3" /><p className="text-zinc-500">No admin activity recorded yet.</p></div> : (
          <Table>
            <TableHeader><TableRow className="border-border hover:bg-transparent">{["Action", "Detail", "Actor", "Time"].map((h) => <TableHead key={h} className="text-zinc-500 uppercase text-xs tracking-widest">{h}</TableHead>)}</TableRow></TableHeader>
            <TableBody>{logs.map((l, i) => {
              const meta = ACTION_META[l.action] || { icon: ScrollText, label: l.action, color: "text-zinc-400" };
              const Icon = meta.icon;
              return (
                <TableRow key={i} data-testid={`audit-row-${i}`} className="border-border row-in">
                  <TableCell><span className={`inline-flex items-center gap-2 font-semibold ${meta.color}`}><Icon className="h-4 w-4" />{meta.label}</span></TableCell>
                  <TableCell className="text-zinc-300">{describe(l)}</TableCell>
                  <TableCell className="text-zinc-400 text-sm">{l.actor_email}</TableCell>
                  <TableCell className="font-mono text-xs text-zinc-500">{l.at ? new Date(l.at).toLocaleString() : "—"}</TableCell>
                </TableRow>
              );
            })}</TableBody>
          </Table>
        )}
      </div>
    </div>
  );
}
